import { useEffect } from 'react';

/** Keeps the screen on while someone is scanning. Not every browser has it. */
export function useWakeLock(active: boolean): void {
  useEffect(() => {
    if (!active || typeof navigator === 'undefined' || !('wakeLock' in navigator)) return;
    let lock: WakeLockSentinel | undefined;
    let gone = false;
    navigator.wakeLock
      .request('screen')
      .then((l) => {
        if (gone) void l.release();
        else lock = l;
      })
      .catch((err: unknown) => console.warn('The screen could not be kept awake.', err));
    return () => {
      gone = true;
      void lock?.release();
    };
  }, [active]);
}
